import { render, staticRenderFns } from "./NewSocialWorker.vue?vue&type=template&id=63a536ac&scoped=true"
import script from "./NewSocialWorker.vue?vue&type=script&lang=js"
export * from "./NewSocialWorker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a536ac",
  null
  
)

export default component.exports